export default __webpack_public_path__ + "static/media/shuffle.75f828d5.svg";